import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthProvider';
import { useTheme } from './useTheme';
import { supabase } from './supabaseClient';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };
const font = "'DM Sans', sans-serif";

export default function AutoReminders() {
  const { user, profile } = useAuth();
  const t = useTheme();
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    if (!user) return;
    const checks = [];

    // Check no sales in 3 days
    supabase.from('daily_sales').select('created_at').eq('user_id', user.id).order('created_at', { ascending: false }).limit(1).then(({ data }) => {
      if (!data || data.length === 0) {
        checks.push({ emoji: '💰', text: 'Registra tu primera venta para empezar a ver tus métricas', color: C.mango });
      } else {
        const last = new Date(data[0].created_at);
        const days = (Date.now() - last) / (1000 * 60 * 60 * 24);
        if (days > 3) checks.push({ emoji: '💰', text: `Llevas ${Math.floor(days)} días sin registrar ventas. ¡No pierdas el ritmo!`, color: C.mango });
      }

      // Check no metrics in 2 weeks
      supabase.from('social_metrics').select('created_at').eq('user_id', user.id).order('created_at', { ascending: false }).limit(1).then(({ data: mData }) => {
        if (!mData || mData.length === 0) {
          checks.push({ emoji: '📊', text: 'Ingresa tus métricas de redes para recibir diagnóstico con IA', color: C.turquesa });
        } else {
          const last = new Date(mData[0].created_at);
          const days = (Date.now() - last) / (1000 * 60 * 60 * 24);
          if (days > 14) checks.push({ emoji: '📊', text: 'Actualiza tus métricas de redes. Tu diagnóstico quincenal está esperando.', color: C.turquesa });
        }
        setReminders(checks);
      });
    });
  }, [user]);

  if (reminders.length === 0) return null;

  return (
    <div style={{ marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', gap: 8 }}>
      {reminders.map((r, i) => (
        <div key={i} style={{ background: r.color + '10', border: `0.5px solid ${r.color}30`, borderRadius: 14, padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 20 }}>{r.emoji}</span>
          <p style={{ fontSize: 13, margin: 0, color: t.text, flex: 1 }}>{r.text}</p>
        </div>
      ))}
    </div>
  );
}
